import { $Formutil, connect, EasyField } from 'react-bootstrap-formutil';
import Checkbox from 'components/forms/Checkbox';
import type { FormCheckType } from 'types/common';
import type { CustomerInfoKeyType } from 'types/customer';
import { printf } from 'utils/i18n';
import './style.scss';

export const defaultFieldsOfEnhanceProgram: CustomerInfoKeyType[] = ['enhance_perm'];

export interface EnhanceProgramFormutil {
    enhance_perm: FormCheckType;
    temporary_confirm_fpsl_agreement?: boolean;
}

interface EnhanceProgramProps {
    $formutil: $Formutil<EnhanceProgramFormutil>;
    disabled?: boolean;
}

const EnhanceProgram: React.FC<EnhanceProgramProps> = ({ disabled }) => {
    return (
        <div className="security-leading-program-root">
            <div className="header-container">
                <h4 className="mt-4 mb-3">{__('Fully Paid Securities Lending Program')}</h4>
                <div className="fs-6 text-secondary">
                    {__(
                        'The Fully Paid Securities Lending (FPSL) program is a program where TradeUP, according to market demand, lends the stocks from your long positions to investors who are willing to short and pay the securities lending interest, and subsequently pays part of the interest to you in return. The interest is accrued daily and credited monthly.'
                    )}
                </div>
            </div>
            <Checkbox
                name="enhance_perm"
                checked="1"
                unchecked="0"
                $defaultValue="1"
                disabled={disabled}
                label={
                    <div
                        dangerouslySetInnerHTML={{
                            __html: printf(
                                __(
                                    'I have read the %s and the %s and am willing to participate in the fully paid securities lending program. I further acknowledge that the FPSL program is a yield enhancement product, and by authorizing TradeUP to lend out their securities, voting rights and SIPC coverage for those securities may be lost.'
                                ),
                                `<a href="https://www.tradeup.com/agreement/207" target="_blank" data-inapp-blank>${__(
                                    'Master Securities Lending Agreement'
                                )}</a>`,
                                `<a href="https://www.tradeup.com/agreement/208" target="_blank" data-inapp-blank>${__(
                                    'Fully Paid Securities Lending Program Disclosure'
                                )}</a>`
                            )
                        }}></div>
                }
            />
            {/* 标记是否阅读弹窗协议 */}
            <EasyField name="temporary_confirm_fpsl_agreement" type="hidden" $defaultValue={false} />
        </div>
    );
};

export default connect(EnhanceProgram);
export * from './components/AgreementModal';
